import { UATConstants } from 'src/Common/Models/UATConstants';
import {
  ITenantUIConfig,
  TenantProvider,
} from 'src/tenantConfig/interface/index.ts';
import { MEAFilterConfig } from './filters/MEAFilterConfig';

export const MEATenantConfig: Partial<ITenantUIConfig> = {
  nodeName: ['MEA Bedrock'],
  provider: TenantProvider.ADO,
  TenantExperience: true,
  FeatureConfig: {
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: MEAFilterConfig,
      AreaPath: [UATConstants.MEA_DefaultValue_AreaPath],
      Title: UATConstants.TenantTitles.MEA,
      ADOTitle: UATConstants.TenantADOText.MEA,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateMEARequest,
          Key: UATConstants.CreateActionMenuKey.CreateMEARequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: true,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {
        tenantToolName: 'mea',
        title: UATConstants.PlaceholdersAndTitles.MEATitle,
        excelColumnSequence: {
          'Title': 1,
          'Action Owner': 2,
          'Account': 3,
          'TPID': 4,
          'EOU': 5,
          'Preferred Region': 6,
          'SKU 1': 7,
          'Core Count 1': 8,
          'SKU 2': 9,
          'Core Count 2': 10,
          'SKU 3': 11,
          'Core Count 3': 12,
          'Is Bedrock Customer': 13,
          'Support Case Number': 14,
          'Status Update': 15,
        },
      },
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [
        { formFieldName: 'assignedTo', apiFieldName: 'assignedTo' },
        { formFieldName: 'requestor', apiFieldName: 'requestor' },
      ],
      Header: {
        Tags: true,
        Actions: {
          Follow: false,
          Email: false,
          CopyLink: false,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
          showRemoteRelatedLink: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: false,
          DiscussionInsights: false,
        },
        StatusUpdate: false,
        ClosureStatement: false,
        Discussion: false,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      showAddViewButton: true,
      showAddFolderButton: false,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
    },
  },
};
